import { ISubstatus } from 'src/interfaces/substatus';

/**
 * Will return an array of substatus of the status given
 *
 * @param {string} status substatus Id
 * @param {ISubstatus[]} substatuses array of substatus
 */
export const filterSubstatus = (status: string, substatuses: ISubstatus[]) =>
    substatuses.filter(
        (item: ISubstatus) => String(item.status) === String(status)
    );
